/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { useNavigate } from 'react-router-dom';
import { FullPetDetailsPropTypes } from '../../../../propTypes/petDetails';
import { CSPUrlsMap } from '../../../../routes/CSPUrlsMap';
import ClaimSavedSuccess from '../../claimSavedSuccess/claimSavedSuccess';
import ClaimSubmitSuccess from '../../claimSubmitSuccess/claimSubmitSuccess';

export const NewClaimResult = ({ status, statusMessage, activePet }) => {
  const showChequeMessage = activePet?.PolicyDetails?.ReimbursementInfo?.paymentMethod === 'Cheque';
  const navigate = useNavigate();

  const ReturnToDashboard = () => {
    navigate(CSPUrlsMap.dashboard.url);
  };

  const handleChangeReimbursementMethod = () => {
    navigate(`${CSPUrlsMap.bankDetails.url}?FullPolicyNumber=${activePet.FullPolicyNumber}`);
  };

  return (
    <main aria-label="New Claim Result">
      {status === 'success' && (
        <ClaimSubmitSuccess
          hideButton
          title="Submitted"
          subTitle="Thanks, we&rsquo;ve received your claim."
          copy={
            <>
              <p>
                Your claim will appear on the dashboard in the next 30 minutes where you can track its status. You will
                receive a confirmation when we begin processing your claim.
              </p>

              <p>If further information is required, we will contact you.</p>
            </>
          }
          showChequeMessage={showChequeMessage}
          handleChangeReimbursementMethod={handleChangeReimbursementMethod}
        />
      )}

      {status === 'saved' && (
        <ClaimSavedSuccess
          hideButton
          copy="Please ensure you finalise and submit within 14 days. Unsubmitted claims will be automatically deleted after
            this time."
        />
      )}

      {status === 'error' && (
        <section className="newClaimStatus">
          <h2>{activePet.PolicyDetails.Species === 'Canine' ? 'Oh my dawg!' : "Oh no. It's a catastrophe!"}</h2>

          <Icon icon="dog-phone" />

          <h3>Something went wrong trying to process your claim.</h3>

          <p>
            Please don&rsquo;t{' '}
            {activePet.PolicyDetails.Species === 'Canine' ? 'send us to the dog house' : 'let the cat get your tongue'}.
            Give us a call and let us sort it out for you.
          </p>

          <p>Please quote the following error message: {statusMessage}</p>
        </section>
      )}

      <footer className="confirmedStepsFooter completed">
        <button
          type="button"
          className="button primary outline"
          onClick={ReturnToDashboard}
        >
          <span className="labelText">Back to Dashboard</span>
        </button>
      </footer>
    </main>
  );
};

NewClaimResult.propTypes = {
  status: PropTypes.oneOf(['success', 'error', 'saved']),
  statusMessage: PropTypes.string,
  activePet: FullPetDetailsPropTypes
};
